export class CFETILMSheerIdApiConstant {
    public static readonly success = 'success';
    public static readonly ILMDocUpload = 'DOC_UPLOAD';
    public static readonly SheerIdDocUpload = 'docUpload';
    public static readonly pending = 'pending'; 
    public static readonly failed = 'failed';
    public static readonly instantVerification = 'INSTANT_VERIFICATION';
    public static readonly reviewDocuments = 'review_documents';
    public static readonly submitDocuments = 'submit_documents';
    public static readonly verificationSuccess = 'verification_success';
    public static readonly processName = 'verify';
    public static readonly source = 'cfet';
    public static readonly submit_documents_error = 'submit_documents_error';
    public static readonly completed = 'completed';
}
